module.exports = __webpack_public_path__ + "4e010b929d0b71314a368114b9c66a83.svg";